export const programsData = [
  {
    title: " IDEATE",
    about:"We assist students in identifying problems and proposing solutions, fueling successful enterprises."
  },
  {
    title: " INNOVATE",
    about: "Our belief in Exposure to technology breeds innovation drives us to cultivate innovative mindsets"
  },
  {
    title: " IMPLEMENT  ",
    about: " We guide students along the entrepreneurial path, helping them transform ideas into tangible realities."
  },
  {
    title: " INCUBATE  ",
    about: "We facilitate seamless interaction between students, faculty, and entrepreneurs, nurturing groundbreaking ideas."
  },
];
